import React from "react";
import { motion } from "framer-motion";
import { DTU, CBS, Microsoft } from "@assets";
import "./LogoCarousel.css";
import { useDarkMode } from "@hooks/dark-mode";

const LogoCarousel = () => {
    const { dark } = useDarkMode();

    const logos = [
        { src: DTU, alt: "DTU Logo" },
        { src: CBS, alt: "CBS Logo" },
        { src: Microsoft, alt: "Microsoft Logo" },
    ];

    return (
        <div className="marquee-container">
            <motion.div
                className="marquee"
                animate={{
                    x: [0, -50 * logos.length * 25],
                }}
                transition={{
                    duration: 100,
                    ease: "linear",
                    repeat: Infinity,
                }}
            >
                <div className="marquee-content">
                    {Array.from({ length: 25 }).flatMap((_unused, i) =>
                        logos.map((logo, index) => (
                            <div key={`logo-${i}-${index}`} className="marquee-item">
                                <img
                                    src={logo.src}
                                    alt={logo.alt}
                                    className={`logo ${dark ? 'dark-logo' : ''}`}
                                />
                            </div>
                        ))
                    )}
                </div>
            </motion.div>
        </div>
    );
};

export default LogoCarousel;